module.exports = __webpack_public_path__ + "img/ivanmagalhaes.79ea59a8.png";